
import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component
export default class MobileSectionStrip extends Vue {
  $refs!: { scroller: HTMLElement };

  @Prop({ default: () => [] }) readonly items!: any[];
  @Prop({ default: "" }) readonly currentNombreWeb!: string;
  @Prop({ default: "" }) readonly sectionLabel!: string;

  private mounted() {
    this.$nextTick(() => this.scrollToActive());
  }

  @Watch("currentNombreWeb")
  private onCurrentChange() {
    this.$nextTick(() => this.scrollToActive());
  }

  private scrollToActive() {
    const scroller = this.$refs.scroller;
    if (!scroller) return;
    const active = scroller.querySelector(
      ".mobile-section-chip--active"
    ) as HTMLElement | null;
    if (active) {
      active.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
        inline: "center"
      });
    }
  }

  private emitNavigate(item: any) {
    this.$emit("navigate", item);
  }

  private isSelectedMenuItem(item: any) {
    if (this.currentNombreWeb == item.nombre_web) {
      return true;
    }
    if (item.sub_menu && item.sub_menu.length > 0) {
      for (let i = 0; i < item.sub_menu.length; i++) {
        if (this.currentNombreWeb == item.sub_menu[i].nombre_web) {
          return true;
        }
      }
    }
    return false;
  }
}
